import { Pipe, PipeTransform } from '@angular/core';

import { PlatformDiscountStatus } from 'src/shared/services/listing-calendar.service';

/**
 * Short note for a per-platform discount that hasn't landed yet. Empty for
 * `synced` and `configured` — those are settled states and need no callout.
 *
 * A `failed` says "will retry" because it genuinely does: the backend retries
 * after 1, 5 and 15 minutes and a daily sweep re-runs anything still pending,
 * so neither pending nor failed is a final answer.
 */
@Pipe({
  name: 'platformSyncNote',
  standalone: true,
})
export class PlatformSyncNotePipe implements PipeTransform {
  transform(status: PlatformDiscountStatus | null | undefined): string {
    if (status === 'pending') { return 'Syncing to platform'; }
    if (status === 'failed') { return 'Sync failed — will retry'; }
    return '';
  }
}
